export default {
    PleasureVessel: 1,
    FishingVessel: 2,
    PassengerBoat: 3,
    PassengerShip: 4,
    MerchantVessel: 5,
    NavalShip: 6,
    RescueVessel: 7,
    Other: 8
};
